export const SET_FOCUSED_RESIDENT_ITEM = 'SET_FOCUSED_RESIDENT_ITEM';

export function setFocusedResidentItem(payload) {
  return {
    type: SET_FOCUSED_RESIDENT_ITEM,
    payload
  };
}
